import stylesheet_9 from '../stylesheets/9.js';
import stylesheet_17 from '../stylesheets/17.js';
import stylesheet_16 from '../stylesheets/16.js';
import stylesheet_18 from '../stylesheets/18.js';
import stylesheet_15 from '../stylesheets/15.js';
import stylesheet_13 from '../stylesheets/13.js';

export const index = 12;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/services/flight-instructor/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/12.36caa67b.js","_app/immutable/chunks/scheduler.2887eafe.js","_app/immutable/chunks/index.387b3ba3.js","_app/immutable/chunks/Wrapper.6637e6f2.js","_app/immutable/chunks/Hero.8f39fbbd.js","_app/immutable/chunks/each.77017db3.js","_app/immutable/chunks/ContentCard.cca2716c.js","_app/immutable/chunks/Roadmap.8b006e20.js","_app/immutable/chunks/Image.bc01061b.js","_app/immutable/chunks/AirplaneTakeoff.25b0c756.js","_app/immutable/chunks/School.41ba20b8.js"];
export const stylesheets = ["_app/immutable/assets/12.478fa175.css","_app/immutable/assets/Wrapper.54de1bd5.css","_app/immutable/assets/Hero.71a30b75.css","_app/immutable/assets/ContentCard.b5a2f49f.css","_app/immutable/assets/Roadmap.0ad4251b.css","_app/immutable/assets/Image.1c236230.css"];
export const fonts = [];
export const inline_styles = () => ({
	"_app/immutable/assets/12.478fa175.css": stylesheet_9,
	"_app/immutable/assets/Wrapper.54de1bd5.css": stylesheet_17,
	"_app/immutable/assets/Hero.71a30b75.css": stylesheet_16,
	"_app/immutable/assets/ContentCard.b5a2f49f.css": stylesheet_18,
	"_app/immutable/assets/Roadmap.0ad4251b.css": stylesheet_15,
	"_app/immutable/assets/Image.1c236230.css": stylesheet_13
});
